module.exports = "/assets/85b2a79bceb064031e2df63fa431c221.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZJ.png
// module id = 2066
// module chunks = 0